var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "96E61950-933A-4317-BCA8-2D67B79A2741") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5-client-profile",
    transform: "translate(-249.000000, -361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-area",
    transform: "translate(60.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "client-profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(16.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attributes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "protection",
    transform: "translate(144.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(6.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(23.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/viewfinder/performance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/protection",
    transform: "translate(0.583333, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52567663,0.754593414 C3.55435458,1.57776613 1.69006778,2.14597225 0.946895178,2.45460405 C0.958177568,5.16399826 1.35289146,7.1656877 2.2062937,8.78953178 C3.06657894,10.4371094 4.42915625,11.7757176 6.53241498,13.0438235 C8.6363402,11.7750446 9.99838923,10.4367084 10.8594536,8.78781576 C11.7073762,7.17440377 12.0951341,5.1794128 12.1058328,2.45113027 C11.4340321,2.16675439 9.55325128,1.59330927 6.52567663,0.754593413 Z M0.850177696,2.49611587 C0.847030637,2.49751759 0.843910829,2.498913 0.840818274,2.5003021 C0.844027647,2.49917188 0.847209054,2.49789979 0.850355583,2.49649123 Z",
    id: "Protection-Icon",
    stroke: "#3386BE",
    strokeWidth: 1.45454545,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52889014,1.5909091 C9.63498628,2.41931327 11.1880344,2.89129089 11.1880344,3.00684196 C11.1880344,5.05267717 10.9035167,6.78472923 10.1925097,8.10460708 C9.48150269,9.43292743 8.32297281,10.5021185 6.76942493,11.5940635 C6.63421311,11.6891001 6.43148548,11.6926204 6.29845563,11.5940635 C4.56655435,10.3109616 3.56285635,9.2451014 2.85192337,7.91678104 C2.14091635,6.59690319 1.86467232,5.05267717 1.86467232,3.00684196 C1.86467232,2.89129089 3.4194116,2.41931327 6.52889014,1.5909091 Z",
    id: "Shape",
    fill: "#3386BE"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewProtection);
export default __webpack_public_path__ + "static/media/view_protection.6fb6e4a80f22e2587f20b348a0b4c95b.svg";
export { ForwardRef as ReactComponent };